export default class NodeCard {
  constructor({
    '#type': type,
    id,
    data_type: dataType,
    algorithm,
    title,
    alias,
    content,
    source,
    profession,
    aoList,
  }) {
    this.type = type;
    this.id = id;
    this.dataType = dataType;
    this.algorithm = algorithm;
    this.title = title;
    this.alias = alias;
    this.content = content;
    this.source = source;
    this.profession = profession;
    this.aoList = aoList;
  }

  getTitle() {
    return this.title;
  }

  getSubTitle() {
    return this.profession;
  }

  getAlias() {
    return this.alias;
  }

  getContent() {
    return this.content;
  }

  getListAO() {
    return this.aoList;
  }

  getSource() {
    return this.source;
  }
}
